import { render, staticRenderFns } from "./Wavely.vue?vue&type=template&id=168a7964"
import script from "./Wavely.vue?vue&type=script&lang=js"
export * from "./Wavely.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports